// Removed import from @shared/documents
import { decodeJwt } from 'jose';
import React, { useEffect, useState } from 'react';

import { axiosInstance, setAccessToken } from '../../config/axios';
import { AuthContext, type User } from '../../hooks/useAuth';

interface AuthProviderProps {
	children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
	const [user, setUser] = useState<User | null>(null);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const initializeAuth = async () => {
			try {
				// Attempt to get a new access token using the HttpOnly refresh token
				const response = await axiosInstance.post('/api/refresh-token');
				const { accessToken } = response.data;

				// Set the token in memory for axios
				setAccessToken(accessToken);

				// Decode and set the user
				const decoded = decodeJwt<User>(accessToken);
				setUser(decoded);
			} catch (error) {
				// If refresh fails, ensure we are logged out state-wise
				setAccessToken(null);
				setUser(null);
			} finally {
				setIsLoading(false);
			}
		};

		initializeAuth();
	}, []);

	return (
		<AuthContext.Provider value={{ user, setUser, isLoading }}>
			{children}
		</AuthContext.Provider>
	);
};
